import state from './examState';
import mutations from './examMutations';
import getters from './examGetters';
import actions from './examActions';

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
